import fromEntries from 'object.fromentries';

if (!Object.fromEntries) {
  (fromEntries as unknown as {shim: () => void}).shim();
}
